import Swiper from 'swiper';
export class Carousel {
    Swiper = Swiper;
    constructor() {
        this.modules = this.getModules();
        this.classes = this.getClasses()
        this.handler();
    }
    
    getModules() {
        return []
    }

    getClasses() {
        return {
            // carousel: '_carousel',
            buttonNext: 'swiper-button-next',
            buttonPrev: 'swiper-button-prev',
            pagination: 'swiper-pagination',
            initialized: '_initialized',
            carouselWrap: '_carousel-wrap',
        }
    }

    getSettings(item) {
        return {
            speed: 700,
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
                nextEl: this.getButtonNext(item),
                prevEl: this.getButtonPrev(item),
            },
            // loop: true,
            pagination: {
                el: this.getPaginationWrap(item),
                clickable: true,
            },
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
        };
    }

    handler() {
        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        this.Swiper.use(this.modules);
        document.querySelectorAll(`.${this.classes.carousel}`).forEach((item) => {
            if (item.classList.contains(`${this.classes.initialized}`)) return;
            this.initItem(item);
            item.classList.add(this.classes.initialized);
        });
    }

    initItem(item) {
        const swiper = this.createSwiper(item)
        this.bindControls(item, swiper);

        if (swiper.params.autoHeight) {
            const images = item.querySelectorAll('.swiper-slide img');
            images.forEach(img => {
                if (!img.naturalHeight) {
                    img.addEventListener('load', (e) => {
                        swiper.updateAutoHeight();
                    })
                }
            })
        }
        return {item, swiper}
    }

    bindControls(item, swiper) {
        
    }

    createSwiper(item) {
        return new Swiper(item, {
            ...this.getSettings(item),
        })
    }

    getPaginationWrap(swiper) {
        return (swiper.closest(`.${this.classes.carouselWrap}`) || swiper).querySelector(`.${this.classes.pagination}`)
    }

    getButtonNext(swiper) {
        return (swiper.closest(`.${this.classes.carouselWrap}`) || swiper).querySelector(`.${this.classes.buttonNext}`)
    }

    getButtonPrev(swiper) {
        return (swiper.closest(`.${this.classes.carouselWrap}`) || swiper).querySelector(`.${this.classes.buttonPrev}`)
    }

    getButtonPlay(swiper) {
        return (swiper.closest(`.${this.classes.carouselWrap}`) || swiper).querySelector(`.${this.classes.play}`)
    }

    pause(swiper, button) {
        swiper.autoplay.stop()
        // button?.classList.add(this.classes.playPaused)
    }
    play(swiper, button) {
        swiper.autoplay.start()
        // button?.classList.remove(this.classes.playPaused)
    }
}
